const Form105SC = {
    stepName: {
        importantNotes: "重要提示",
        partA: "选择文件",
        confirmation: "确认",
    },
    label: {
        applicationPurpose: "提交文件",
        sectionName: "表格名称",
        contactPerson: "是次提交的联络人",
        telephoneNo: "联络人的电话号码",
        emailAddress: "联络人的电邮地址",
        uploadFiles: "选择提交的档案",
        reoCode: "提交副本至区域教育服务处",
        contactInformation:
            "有关是次文件提交事宜，请致电 {{sectionTel}} 与 {{sectionName}} 联络。",
        contactInformationNotTel:
            "有关是次文件提交事宜，请与 {{sectionName}} 联络。",
        scrnOrOrg: "学校 / 机构",
        submittedTo: "请选择：",
        conditionsCheck:
            "我确认将上述{{uploadFilesLength}}个档案提交到{{sectionName}}。",
        helpdesk:
            "有关系统支援，请致电 2694 5892 与「教育局电子表格递交系统」求助台联络。",
        logout: "尚未登录，不能提交这张form。",
    },
    errorMsg: {
        pdfSignRequired: "请签署PDF。",
        exceedTotalSize: "所有档案总共大小最大为45MB。",
    },
    AttachmentInstruction1: "可接受的档案类型：{{types}}",
    AttachmentInstruction2: "每个档案最大为{{size}}MB。",
    AttachmentInstruction3: "档案名称最长为{{length}}个字元。",
    AttachmentInstruction4:
        "如需增加更多档案（最多{{files}}个），请使用“增加”按钮。",
    AttachmentInstruction5: "所有档案总共大小最大为45MB。",
};

export default Form105SC;
